export const MAIN_APP_DASHBOARD_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/account/billing`;

export const MAIN_APP_MIGRATION_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/team`;

export const STRIPE_MANAGE_SUBSCRIPTION_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/external?redirectTo=stripePortal`;

export const MAIN_APP_WELCOME_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/welcome?purchased=1`;

export const MAIN_APP_WELCOME_CREDITS_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/welcome?purchased=credits`;

export const MAIN_APP_MONITORS_REWARD_URL = `${
  import.meta.env.VITE_DASHBOARD_APP_URL
}/monitors?reward=claimed`;
